import { EmpleadoHorario, HistorialSolicitudes, SolicitudCambioHorarioIngresada } from "../../Solicitud Cambio Horario/TypesCambioHorarioPRN"

export type PlanificacionPermisos = {
    "fechaInicio": Date
    "fechaFin": Date,
    "fechaInicioString":string|null ,
    "fechaFinString": string|null,
    "diasOrdinarios": number,
    "tomadas": boolean,
    "estado": string,
    "idPersona": number,
    "idPlanificacionVacaciones":number,
    estadoParse:string
}

export type Replanificacion = {
    fechaInicio:Date,
    fechaFin:Date,
    diasOrdinarios:number,
    editable?:boolean,
    showInTable?:boolean
}

export type TipoSolicitudPermisos = {
    "idtipopermiso"?:number
    "tipo": string
    "horasmax": number,
    "descripcion":string|null ,
    "diasmax": number|null,
    "tipocontrol": string|null,
    "descripcionabrev": string,
    "grupo": number,
    "ultimoCambio": Date,
}

export type SolicitudPermisos = {
    "strTipoPermiso": string,
    "strSubTipoPermiso": string,
    "tipoPermiso": number,
    "idPermiso": number,
    "idDependiente": number | null,
    "estadoPermiso": string,
    "refArchivoCertMedico": string,
    "refArchivoCertProgCita": string,
    "refArchivoPermiso": string| null,
    "observacion": string,
    "fechaSolicitud": string | null,
    "fechaDesde": string|null,
    "fechaHasta": string | null,
    "fechaEvento": string | null,
    "horaDesde": string|null,
    "horaHasta": string | null,
    "horaDesdeTarde": string | null,
    "horaHastaTarde": string | null,
    "permitirEnDias": boolean,
    "permitirEnHoras": boolean,
    "diasSolicitadas": number,
    "horasSolicitadas":string|null,
    "certificadoValidado": string | null,
    "strNombreHijo": string | null,
    "strEstadoPermiso": string | null,
    "identificacionConyuge": string | null,
    "tipoEventoMatrimonio": string | null,
    "modalidadLicenciaMatrimonio": string | null,
    "tipoIdentificacion": string | null,
    "Conyuge": string | null,
    "motivoRechazo": string | null,
    "nrodocautorizacion": string | null,
    "esxresolucion":string | null
}


export type SolicitudLicencias = {
    "strTipoPermiso": string,
    "strSubTipoPermiso": string,
    "tipoPermiso": number,
    "idPermiso": number,
    "idDependiente": number | null,
    "estadoPermiso": string,
    "refArchivoCertMedico": string,
    "refArchivoPermiso": string| null,
    "observacion": string,
    "fechaSolicitud": string | null,
    "fechaDesde": string|null,
    "fechaHasta": string | null,
    "fechaEvento": string | null,
    "horaDesde": string|null,
    "horaHasta": string|null,
    "permitirEnDias": boolean,
    "permitirEnHoras": boolean,
    "certificadoValidado": string | null,
    "diasSolicitadas": number,
    "horasSolicitadas":string|null,
    "strEstadoPermiso": string | null,
    "cedulaConidentificacionConyugeyugue": string | null,
    "tipoEventoMatrimonio": string | null,
    "modalidadLicenciaMatrimonio": string | null,
    "tipoIdentificacion": string | null,
    "Conyuge": string | null,
    "motivoRechazo": string | null
}

export type SubTipoPermisos = {
    "diasanticipacion" : number,
    "diasmax": number | null,
    "diasposterior": number,
    "estado": string,
    "horasmax": number | null,
    "idprnsubtipopermisos": number,
    "idprntipoproceso": number,
    "idtipopermiso": number,
    "idusuario": number|null,
    "mesesmax": number|null,
    "nombre": string,
    "planificado": string|null,
    "tipoduracion": string,
    "tipotiempo": string,
    "ultimoCambio": Date,
    "idprntipoprocesoNavigation":number|null,
}

export type PlanificacionSolicitudVacaciones = {
    "fechaInicio": Date
    "fechaFin": Date,
    "fechaInicioString":string|null ,
    "fechaFinString": string|null,
    "diasOrdinarios": number,
    "tomadas": boolean,
    "estado": string,
    "idPersona": number,
    "idPlanificacionVacaciones":number,
    estadoParse:string
}

export type SolicitudVacaciones = {
    "idSolicitud"?:number
    "fechaInicio": Date
    "fechaFin": Date,
    "fechaInicioString":string|null ,
    "fechaFinString": string|null,
    "diasOrdinarios": number,
    "estadoParse": string,
    "estado": number,
    "idPersona": number,
    nuevas:boolean,
    reintegro:boolean,
    permiso:boolean,
    horadesde:string,
    horahasta:string,
    totalhoras: string,
    nrodocautorizacion: string,
    esxresolucion:string
    
}

export type LicenciasComisiones = {
    "esRemunerada"?: string
    "estado"?: string
    "fechainicio": string
    "fechafin": string,
    "idpersona": number,
    "idrelacioncontratacion": number,
    "nombrelicencia": string,
    "tipolic": string,

}


export type SolicitudReintegroVacaciones = {
    "idSolicitudVacaciones":number,
    "idSolicitudReintegro":number,
    "fechaInicio": Date
    "fechaFin": Date,
    "fechaReintegro": Date,
    "fechaInicioString":string|null ,
    "fechaFinString": string|null,
    "FechaReintegroString": string|null,
    "diasOrdinarios": number,
    "estadoParse": string,
    "estado": string,
    "idPersona": number,
    
}

export type SolicitudReplanificacionVacaciones = {
    "idSolicitudReplanificacion":number,
    "estadoParse":string,
    "estado":number,
    "fechaSolicitud": Date,
    "totalDiasReplanificados":number,
    idSolicitudReintegro:null|number,
    idSolicitudAnulacion:null|number
}

export type TipoSubtipoLicencia = {
    "idprnsubtipopermisos": number
    "nombre": string
}

export type TipoCalamidadDomestica = {
    "idTipoCalamidad"?: number
    "descripcion": string
}

export type Provincias = {
    "idProvincia"?: number
    "nombre": string
}

export type TipoNacimiento = {
    "idTipoNacimiento"?: number
    "descripcion": string
}

export type TipoCertificado = {
    "idTipoCertificado"?: number
    "descripcion": string
}

export type InformacionHijos = {
    "idDependientePersona"?: number
    "nombre": string
    "Identificacion": string
    "strParentesco": string
}


export type SolicitudPermisosPost = {
    FechaInicio:Date|string|null,
    FechaFin: Date|string|null,
    TipoPermiso:number|null,
    Observacion:string|null,
    HoraInicio: string|undefined,
    HoraFin: string|undefined,
    PermisoHoraIncluyeAlmuerzo: boolean,
    idDependiente: number | undefined | null
}


export type SolicitudLicenciasPost = {
    FechaEvento: Date | string | null,
    FechaInicio: Date | string | null,
    FechaFin: Date | string | null,
    TipoPermiso: number | null,
    Observacion: string | null,
    HoraInicio: string | undefined,
    HoraFin: string | undefined,
    Subtipo: number | undefined,
    idProvincia: number | undefined | null
    PermisoHoraIncluyeAlmuerzo?: boolean,
    identificacionConyuge?: string | null,
    tipoEventoMatrimonio?: string | null,
    modalidadLicenciaMatrimonio?: string | null,
    tipoIdentificacion?: string | null,
    Conyuge?: string | null
}

//export type SolicitudLicenciasMatrimonio = {
//    FechaEvento: Date | string | null,
//    FechaInicio: Date | string | null,
//    FechaFin: Date | string | null,
//    TipoPermiso: number | null,
//    Observacion: string | null,    
//}

export type PermisosGozadasCard = {
    Key:string, //MES
    Value:number //DIAS VACACACIONES
}

export type HistorialSolicitudesPermisos = {
    key:string, // ANIO
    value: InformacionPermisosHistorial[]
}

export type HistorialPermisosSolicitudes = {
    identificacion:string,
    nombres:string,
    fechaSolicitud:Date,
    nombreAutoridadAprobo:string,
    tipo:string,
    estado:string,
    documentoCertMedico:string,
    documentoPermiso:string,
    fechaDesde:Date,
    fechaHasta:Date,
    horaDesde: string,
    horaHasta:string,
    diasOrdinarios:number,
    horasSolicitadas:number
}

export type InformacionPermisosHistorial = {
    tipoSolicitud:string,
    fechaInicio:string,
    fechafin:string,
    horaInicio:string,
    horaFin:string,
    estado: string,
    diasSolicitados: number,
    horasSolicitadas: string,
    refSolicitud: string,
    idDependiente:number
}

export type HistorialSolicitudesPermisosbyAnio = {
    key: number, // ANIO
    value: InformacionPermisosHistorial[]
}


export type InformacionGeneralSolicitudes = {
    tiposSolicitudPermisos: TipoSolicitudPermisos[],
    tiposSolicitudLicencias: TipoSolicitudPermisos[],
    solicitudesPermisos:SolicitudPermisos[],
    solicitudesLicencias:SolicitudLicencias[],
    permisosIngresados:SolicitudPermisos[],
    licenciasIngresadas: SolicitudLicencias[],
    permisosCRN: SolicitudPermisos[],
    diasPendientes:number,
    anio:number,
    feriados:Date[],
    esSubrogante:boolean,
    historial:HistorialSolicitudesPermisos[],
    historialbyAnio:HistorialSolicitudesPermisosbyAnio[],
    acuerdoMediosElectronicos:boolean,
    horaEntrada:string,
    horaSalida:string,
    horaInicioAlmuerzo:string,
    horaFinAlmuerzo:string
    tiempoAlmuerzo: string,
    horaEntradaRegimen: string,
    horaSalidaRegimen: string,
    esAprobador:boolean,
    solicitudesVacaciones:SolicitudVacaciones[],
    ubicacionFisica: string,
    licenciasComisiones: LicenciasComisiones[],
    empHorario: EmpleadoHorario[],
    historialSolicitudesCH: HistorialSolicitudes[],
    solicitudesIngresadasCH: SolicitudCambioHorarioIngresada[],
    subtipoPermisos: SubTipoPermisos[]
    horarioLaboralRegimen: HorariolaboralRegimen,
    horarioLaboralPersona: HorariolaboralPersona[],
    jornadaLaboralPersona: JornadalaboralPersona[],
    tieneHorarioPermiso: boolean,
    tieneInfanteRegistrado: boolean,
    vacacionesIngresadas: SolicitudPermisos[],
    estadoCivil: string,
    identificacionConyuge: string,
    tipoEventoMatrimonio: string,
    modalidadLicenciaMatrimonio: string,
    tipoIdentificacion: string,
    Conyuge: string,
    idRegimenLaboralS: number,
    listadoHorarios: HorariosCambioPRN[],
    licenciaMaternidad: SolicitudLicencias[],
    fechaFinContrato: string,
}

export type HorariosCambioPRN = {
    idRegimenLaboral: number,
    horaInicioR1: string,
    horaFinR1: string,
    horaInicioR2: string | null,
    horaFinR2: string | null
}

export type InformacionJornadaHorario = {
    horarioLaboralPersona: HorariolaboralPersona[],
    jornadaLaboralPersona: JornadalaboralPersona[]
}

export type horarioLaboralServidor = {
    horaEntrada:string,
    horaSalida:string
}

export type horarioAlmuerzoServidor = {
    horaInicio:string,
    horaFin:string,
    tiempo:string
}


export type InformacionDetalleHistorialSolicitudPermisos = {
    tabladetalle:TablaDetalleHistorialSolicitudPermisos[],
    totalDiasOrdinarios:number
}
export type TablaDetalleHistorialSolicitudPermisos = {
    tipoSolicitud:string,
    fechaInicio:string,
    fechaFin: string,
    fechaVigHasta: string,
    fechaSolicitud:string,
    horaInicio:string,
    horaFin:string,
    observacion:string,
    causaRechazo:string,
    estadoPermiso:string,
    referenciaArchivo: string,
    referenciaPermiso:string,
    diasSolicitados:number,
    horasSolicitadas:number,
    referenciaProgCita: string
    referenciaAp: string
}


export type HorariolaboralRegimen =  {
    idRegimen: number,
    horaEntrada: string,
    horaSalida: string,
    horaInicioReceso: string,
    horaFinReceso: string
}

export type HorariolaboralPersona =  {
    idpersona: number,
    idpersonahorario: number,
    horaentrada: string,
    horasalida: string,
    horainicioreceso: string,
    horafinreceso: string
}

export type JornadalaboralPersona =  {
    idpersona: number,
    fechajornada: string,
    estadojornada: number,
    codigo: string,
    descripcion: string
}

export type NuevoHorarioCRN = {
    horaEntrada: string,
    horaSalida: string,
    horaEntradaTarde?: string,  // Hacer opcional ya que no todos los horarios son mixtos
    horaSalidaTarde?: string,   // Hacer opcional ya que no todos los horarios son mixtos
    fechaDesde: string,
    fechaHasta: string,
    observacion: string,
    horaEntradaLaboral: string,  // Nueva propiedad
    horaSalidaLaboral: string    // Nueva propiedad
}

export type InfanteRegistrado = {
    tipoidentificacion: string,
    numeroidentificacion: string,
    nombres: string,
    apellidos: string,
    fechaNacimiento: string,
    sexo: string,
    usoGuarderia: string
}

export enum EstadosParseSolicitudesVacaciones {
    ANULADA= "Anulada",
    RECHAZADA = "Negada"
}

export enum TiposPermiso {
    ATENCION_MEDICA = "AM",
}

export enum EstadoPlanificacionConSolicitud {
    EJECUTADO = "Ejecutado",
    NO_EJECUTADO = "No Ejecutado",
    PENDIENTE = "Pendiente de Ejecutar",
    JUSTIFICADA ="Justificada",
    // JUSTIFICADA = "Planificada no ejecutada-Justificada",
    JUSTIFICACION_INGRESADA ="Justificación Ingresada",

    POR_EJECUTAR = "Por Ejecutar",
    REPLANIFICACION_INGRESADA ="Replanificación Ingresada",
    REPLANIFICADA ="Replanificada",
    EN_EJECUCION = "En ejecución"
    // REPLANIFICADA = "Planificada no ejecutada-Reprogramada"
}


export enum TabSolicitudActiva {
    PERMISOS = 1,
    LICENCIAS = 2,
}

export type InformacionConyugueData = {    
    apellidos: string,
    nombres: string,
    nombrecompleto: string,    
    numeroidentificacion: string,
    tipoidentificacion: string,    
    estadocivil: string,
    nombreconyugue: string,
}

